/* eslint-disable react/style-prop-object */
import * as React from 'react';
import { SvgIcon } from '@mui/material';

export default function UploadIcon() {
  return (
    /* eslint-disable react/jsx-props-no-spreading */
    <SvgIcon>
      <path d="m8 8 4-4 4 4" fill="none" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 4v12M19 17v.6c0 1.33-1.07 2.4-2.4 2.4H7.4C6.07 20 5 18.93 5 17.6V17" fill="none" stroke="#6b7280" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round"/>
    </SvgIcon>
    /* eslint-enable react/jsx-props-no-spreading */
  );
}
